import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=8f448f82&scoped=true"
import script from "./normal.vue?vue&type=script&setup=true&lang=js"
export * from "./normal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./normal.vue?vue&type=style&index=0&id=8f448f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f448f82",
  null
  
)

export default component.exports